import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import StructurePreviewComponent from '@Components/Results/structure/structure-preview.component';
import MarkushGroup from '@Components/Results/substances/tables/markush/markush-group.component';
import StickyTableHeaderComponent from '@Components/Results/sticky-table-header.component';

export default class MarkushDetails extends React.PureComponent {
  static headers = [
    { title: 'Label' },
    { title: 'Value' },
    { title: 'Size' },
    { title: 'Attributes' },
    { title: 'Substituted by' },
    { title: 'Frequency' },
  ];

  constructor(props) {
    super(props);
    this.uid = uniqueId('markush');
  }

  render() {
    const { data } = this.props;

    return (
      <div className="substance-results-markush">
        <div className="substances-item-wrapper">
          <StructurePreviewComponent markushPreview={data.path} />
        </div>
        <div className="clearfix scroller scrollbar-container">
          <table className="rx-table sticky-table-header rx-table--quantitative">
            <StickyTableHeaderComponent headers={MarkushDetails.headers} staticColumns />
            {data.groups.map((group) => (
              <MarkushGroup uid={this.uid} group={group} />
            ))}
          </table>
        </div>
      </div>
    );
  }
}

MarkushDetails.propTypes = {
  data: PropTypes.object.isRequired,
};
